import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { ControlLabel, DropdownButton, FormGroup, MenuItem } from 'react-bootstrap';
import { filter, includes } from 'lodash/collection';
import { isArray } from 'lodash/lang';
import { keys } from 'lodash/object';
import { xor } from 'lodash/array';

class MultiSelectButton extends Component {

  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
    const selectedItems = isArray(this.props.activeItems) ? this.props.activeItems : [];
    this.state = { selectedItems };
  }

  componentWillReceiveProps(nextProps) {
    let itemKeys = keys(this.props.items);
    if (!itemKeys.length && nextProps.items) {
      itemKeys = keys(nextProps.items);
    }
    const selectedItems = filter(nextProps.activeItems, item => includes(itemKeys, item));
    this.setState({ selectedItems });
  }

  handleSelect(clickedItem) {
    const newSelectedItems = clickedItem !== 0 ?
      xor(this.state.selectedItems, [clickedItem]) : [];
    this.setState({ selectedItems: newSelectedItems });
    this.props.onSelect(this.props.id, newSelectedItems);
  }

  render() {
    const { id, label, className, items, t } = this.props;
    const itemArray = Object.keys(items).map(key => Object.assign({}, items[key], { id: key }))
    .sort((a, b) => (a.name > b.name ? 1 : -1));

    const menuItems = itemArray.map(item => (
      <MenuItem
        key={item.id}
        eventKey={item.id}
        active={includes(this.state.selectedItems, item.id)}
      >
        {item.name}
      </MenuItem>
    ));
    const menuItemComponent = menuItems.length > 1 ?
      (
        <MenuItem
          key={0}
          eventKey={0}
          active={includes(this.state.selectedItems, 0)}
        >
          {t('filters.select')}
          <MenuItem 
            divider aria-label={t('common:ariaLabels.divider')}
          />
        </MenuItem>
      ) : null;
    const activeItems = itemArray.filter(item =>
      includes(this.state.selectedItems, item.id));

    let theTitle = t('filters.select');
    if (activeItems.length === 1) {
      theTitle = activeItems[0].name;
    } else if (activeItems.length > 1) {
      theTitle = `${activeItems.length} valittu`;
    }

    return (
      <FormGroup className={`filter-multi-select ${className}`}>
        <ControlLabel htmlFor={id}>{label}</ControlLabel>
        <DropdownButton
          className="filter-multi-select-btn"
          aria-label={`${t('common:ariaLabels.dropdownButton')}-${theTitle}`}
          id={id}
          title={theTitle}
          onSelect={(eventKey) => { this.handleSelect(eventKey) }}
        >
          {menuItemComponent}
          {menuItems}
        </DropdownButton>
      </FormGroup>
    );
  }
}

MultiSelectButton.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  items: PropTypes.object.isRequired,
  activeItems: PropTypes.array,
  onSelect: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

MultiSelectButton.defaultProps = {
  className: '',
  activeItems: []
};

export default translate(['booking'], { wait: true })(MultiSelectButton);



// WEBPACK FOOTER //
// ./src/containers/MultiSelectButton/MultiSelectButton.jsx